import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
  },
  {
    path: "/carta",
    name: "Carta",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Carta.vue"),
  },
  {
    path: "/grupo/:id",
    name: "Grupo",
    props: route => ({ groupId: route.params.id }),
    component: () => import("../views/Carta.vue"),
  },
  {
    path: "/menu",
    name: "Menu",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Menu.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
